import store from '../../index.js'

const state = {
  filters: {},
  signalFilterChanged: false,
}

const getters = {
  getFilters: state => state.filters,
  getHaveFiltersChanged: state => state.signalFilterChanged,
}

const mutations = {
  loadFiltersFromLocalStorage (state, filters) {
    state.filters = JSON.parse(filters)
  },
  saveFilter (state, payload) {
    const compositeKey = payload.storeKey + (payload.layerKey || payload.layerKey === 0 ? `##${payload.layerKey}` : '')
    const localStoragePropName = `filters-${store.getters.getViewerName}` + (store.getters.getLoggedInUser?.username ? `-${store.getters.getLoggedInUser.username}` : '')

    if (payload.filter) {
      state.filters = {
        ...state.filters,
        [compositeKey]: payload.filter,
      }
    } else {
      const tempFilters = { ...state.filters }
      delete tempFilters[compositeKey]
      state.filters = tempFilters
    }
    state.signalFilterChanged = !state.signalFilterChanged
    localStorage.setItem(localStoragePropName, JSON.stringify(state.filters))
  },
}

const actions = {
  saveFilter ({ commit }, payload) {
    commit('saveFilter', payload)
  },
  loadFiltersFromLocalStorage ({ commit }, payload) {
    commit('loadFiltersFromLocalStorage', payload)
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
